import { Injectable } from '@angular/core';
import { AvisInitialTypeLight } from '../../models/AvisInitialTypeLight';

@Injectable({
  providedIn: 'root',
})
export class AvisInitialService {
  constructor() {}

  public getAvisInitial(controls: any): AvisInitialTypeLight {
    const avisInitial = new AvisInitialTypeLight();
    avisInitial.idWeb = controls.get('_SepSep_TypeAnn_SepSep_Rectificatif_SepSep_AvisInitialType_SepAtt_idWeb');
    avisInitial.datePublication = controls.get('_SepSep_TypeAnn_SepSep_Rectificatif_SepSep_AvisInitialType_SepAtt_datePublication');

    return avisInitial;
  }
}
